import tinycolor from "tinycolor2";




export function setCssColorVariable(colorName: string, value: string) {
  // RGB value is used by tailwind.config.js
  document.documentElement.style.setProperty(colorName + '-rgb', getRGBColor(value));
  document.documentElement.style.setProperty(colorName, value);
}


export function generateAngularMaterialPrimaryColor(mainColor: string) {
  // Angular material
  const palette = computeColors(mainColor);
  for (const color of palette) {
    const key1 = `--theme-primary-${color.name}`;
    const value1 = color.hex;
    const key2 = `--theme-primary-contrast-${color.name}`;
    const value2 = color.darkContrast ? 'rgba(black, 0.87)' : 'white';
    document.documentElement.style.setProperty(key1, value1);
    document.documentElement.style.setProperty(key2, value2);
  }
}

export function generateAngularMaterialAccentColor(mainColor: string) {
  // Angular material
  const palette = computeColors(mainColor);
  for (const color of palette) {
    const key1 = `--theme-secondary-${color.name}`;
    const value1 = color.hex;
    const key2 = `--theme-secondary-contrast-${color.name}`;
    const value2 = color.darkContrast ? 'rgba(black, 0.87)' : 'white';
    document.documentElement.style.setProperty(key1, value1);
    document.documentElement.style.setProperty(key2, value2);
  }
}


function computeColors(hex: string): Color[] {
  return [
    getColorObject(tinycolor(hex).setAlpha(0.2), '50'),
    getColorObject(tinycolor(hex).setAlpha(0.3), '100'),
    getColorObject(tinycolor(hex).setAlpha(0.5), '200'),
    getColorObject(tinycolor(hex).setAlpha(0.7), '300'),
    getColorObject(tinycolor(hex).setAlpha(0.9), '400'),
    getColorObject(tinycolor(hex), '500'),
    getColorObject(tinycolor(hex).darken(6), '600'),
    getColorObject(tinycolor(hex).darken(12), '700'),
    getColorObject(tinycolor(hex).darken(18), '800'),
    getColorObject(tinycolor(hex).darken(24), '900'),
  ];
}

function getColorObject(value, name): Color {
  const c = tinycolor(value);
  return {
    name: name,
    hex: c.toHex8String(),
    darkContrast: c.isLight()
  };
}


export interface Color {
  name: string;
  hex: string;
  darkContrast: boolean;
}


export const getRGBColor = (hex) => {
  return tinycolor(hex).toRgbString().replace("rgb(", "").replace(")", "")
}
